import { navigation } from '../app/navigation.js';
import { assert } from '../app/logger.js';
import { PopupButtonControl } from '../controls/popup_button_control.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';

/**
 * Trip menu control.
 */
class TripMenuControl extends PopupButtonControl {
  constructor() {
    super();

    this.img = '/images/app_icons.svg#menu_vertical';
    this.name = 'Actions';

    listenToEvent(this, 'itemselect', ev =>
      this.invoke(ev.detail && ev.detail.type)
    );
  }

  setData(data) {
    assert(data, `[trip-menu-control] no data to set`);

    this.#data = data;
    this.setItems([
      {
        img: '/images/app_icons.svg#copy',
        name: 'Clone',
        title: 'Clone trip',
        type: 'clone',
      },
      {
        img: '/images/app_icons.svg#waste',
        name: 'Remove',
        title: 'Remove trip',
        type: this.#data.inviteHash ? 'reject' : 'remove',
      },
    ]);
  }

  invoke(type) {
    switch (type) {
      case 'clone':
        navigation.tripPlanning.cloneTrip(this.#data);
        break;

      case 'remove': // remove own trip
        navigation.tripPlanning.removeTrip(this.#data);
        break;

      case 'reject': // reject shared trip
        navigation.tripPlanning.rejectShare(this.#data);
        break;

      default:
        break;
    }
  }

  #data;
}

window.customElements.define('trip-menu-control', TripMenuControl);

export { TripMenuControl };
